import { useLoggedInUser } from "@wac-web/utils/logged-in-user-provider";

import { Stack } from "@atlaskit/primitives-next";

import { CustomerNameAndLogoHeader } from "@/common/customer-name-and-logo-header";
import { useRoutes } from "@/common/hooks/useRoutes";
import { LegalBanner } from "@/common/legal-footer/src/legal-banner";
import { RelationshipSection } from "@/common/relationships";
import { getCurrentTime } from "@/common/utils";
import { CustomerWelcomeBanner } from "@/common/welcome-banner";
import { useFastshiftSelector } from "@/state";

import { useDashboardPageAnalytics } from "./hooks";
import { MigrationTicketsList } from "./migration-tickets-list";
import { RollupStatusSection } from "./rollup-status-section";
import { SummarySection } from "./summary-section";

export const FastshiftDashboard = () => {
    const { data: userDetails } = useFastshiftSelector(
        (state) => state.userDetails
    );

    const { paths } = useRoutes();

    const userInfo = useLoggedInUser();
    const currentTime = getCurrentTime();

    useDashboardPageAnalytics();

    return (
        <Stack space="space.300">
            {userDetails?.userType === "CUSTOMER" && (
                <Stack space="space.300">
                    <CustomerWelcomeBanner
                        currentTime={currentTime}
                        userName={userInfo?.name}
                    />
                    <LegalBanner />
                </Stack>
            )}
            {userDetails?.userType !== "CUSTOMER" && (
                <CustomerNameAndLogoHeader />
            )}
            <Stack space="space.400">
                <RollupStatusSection />
                <SummarySection />
                <MigrationTicketsList
                    migrationTicketsUrl={paths.domainScopedTickets}
                />
                <RelationshipSection />
            </Stack>
        </Stack>
    );
};
